import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import {MenuButtonCodeBlock} from 'mui-tiptap';

const StyledEditorMenuButtonCodeBlock = styled(MenuButtonCodeBlock)`
  ${ComponentStyles}
`;

StyledEditorMenuButtonCodeBlock.propTypes = {
  theme: PropTypes.object
};

export default StyledEditorMenuButtonCodeBlock;
